import {
  BellRing,
  Building2,
  Database,
  Factory,
  FileBarChart,
  FileCode2,
  Gauge,
  LayoutDashboard,
  Router,
  Settings,
  Tags,
  type LucideIcon,
} from 'lucide-react'

/**
 * Maps manifest icon names (strings in tap.config.json) to lucide components.
 * Keeping this explicit — rather than dynamic lookup — keeps the icon set
 * tree-shakeable and the manifest validated at a glance.
 */
const ICONS: Record<string, LucideIcon> = {
  LayoutDashboard,
  Factory,
  Router,
  Tags,
  BellRing,
  Gauge,
  FileBarChart,
  Building2,
  Settings,
  FileCode2,
  Database,
}

export function NavIcon({ name, size = 16 }: { name: string; size?: number }) {
  const Icon = ICONS[name] ?? LayoutDashboard
  return <Icon size={size} />
}
